import React from 'react';
import { Modal, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import classes from '../tenants-page.module.scss';

type CreateTenantModalProps = {
  isOpen: boolean;
  companyName: string;
  isCreating: boolean;
  onClose: () => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCompanyNameChange: (value: string) => void;
};

export const CreateTenantModal: React.FC<CreateTenantModalProps> = ({
  isOpen,
  companyName,
  isCreating,
  onClose,
  onSubmit,
  onCompanyNameChange,
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title="צור חברה חדשה"
      centered
      radius="md"
      withinPortal
      closeOnClickOutside={false}
      trapFocus={false}
      closeButtonProps={{ 'data-testid': 'tenants-create-close' } as Record<string, string>}
    >
      <form onSubmit={onSubmit} noValidate>
        <TextInput
          label="שם החברה"
          placeholder="שם החברה"
          value={companyName}
          onChange={(event) => onCompanyNameChange(event.currentTarget.value)}
          minLength={2}
          maxLength={120}
          required
          size="md"
          radius="md"
          data-testid="tenants-create-company-name"
        />
        <div className={classes.modalActions}>
          <Button variant="cancel" onClick={onClose} disabled={isCreating} dataTestId="tenants-create-cancel">
            ביטול
          </Button>
          <Button type="submit" variant="save" loading={isCreating} loadingLabel="יוצר..." dataTestId="tenants-create-submit">
            צור
          </Button>
        </div>
      </form>
    </Modal>
  );
};
